












































import {Component, Prop, Vue} from "vue-property-decorator";
import QTableHeader from "@/common/qTableHeader.vue";
import User from "@/model/user";
import click2Top from "@/common/directives/click2Top";
import qNotify from "@/common/qNotify";
import userApi from "@/api/userApi";
@Component({
  name: "getStaffList",
  directives: {
    click2Top,
  },
  components: {
    QTableHeader,
  },
})
export default class getUserList extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  users: User[];

  public headers = [
    { id: "id", name: "ID" },
    { id: "username", name: "ユーザー名" , order: "asc" },
    { id: "email", name: "MAIL", order: "asc" },
    { id: "affiliation_company_name", name: "所属", order: "asc" },
    { id: "role", name: "権限", order: "asc" },
    { id: "", name: "" },
  ];

  public editCooperate(user, cooperateIndex) {
    const userCompanyCooperation = {
      id: user.user_company.id,
      role_id: user.user_company.role_id,
      company_id: user.user_company.company_id,
      affiliation_company_id: user.user_company.affiliation_company_id,
      company_name: user.user_company.affiliation_company_name,
      user_id: user.id,
      user_name: user.username,
    };
    this.$emit('editCooperate', {
      userCompanyCooperation: userCompanyCooperation,
      cooperateIndex: cooperateIndex
    });
  }

  public deleteCooperate(name, cooperateId, index) {
    this.$modal.showDelete({
      text: this.$t("users.delete_cooperation", { user_name: name }),
      confirmText: this.$t("confirm_text.yes"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await userApi.deleteCooperate(cooperateId);
        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("users.cooperation_deleted"),
          });
          this.users.splice(index, 1);
        } else {
          qNotify.error({
            text: this.$t("users.cooperation_deleted_fail"),
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }
}
